<template lang="html">
    <div v-if="images && images.length > 0" class="gallery">
        <div class="gallery-slideshow" ref="gallery" @scroll="updateIndex">
            <div class="gallery-slide" @mousemove="arrows" ref="slide" :class="{ active: activeIndex == index }" v-for="(image, index) in images" :key="index">
                <img
                    class="lazyload"
                    :class="{ border: border }"
                    @click="changeSlide(index, $event)"
                    :src="image.thumb"
                    :srcset="image.srcset"
                    :width="image.width"
                    :height="image.height"
                    sizes="(max-width: 768px) 100vw, 50vw"
                    :alt="image.alt"
                />
            </div>
        </div>
        <div class="gallery-info">
            <div class="gallery-caption" v-html="images[activeIndex].caption"></div>
            <div v-if="document" class="gallery-download">
                <a target="_blank" :href="document.url">Download PDF</a>
            </div>
            <div class="gallery-counter">
                {{ activeIndex + 1 }}/{{ images.length }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: Array,
        document: Object,
        border: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            slideHeight: null,
            activeIndex: 0,
        };
    },
    methods: {
        updateIndex(event) {
            this.activeIndex = Math.round(event.target.scrollLeft / event.target.clientWidth);
        },
        arrows(event) {
            if (event.target.clientWidth / 2 > event.layerX - event.target.getBoundingClientRect().left) {
                this.$refs.gallery.classList.add("prev");
                this.$refs.gallery.classList.remove("next");
            } else {
                this.$refs.gallery.classList.remove("prev");
                this.$refs.gallery.classList.add("next");
            }
        },
        changeSlide(index, $event) {
            let smoothscroll = window.innerWidth < 768 ? "smooth" : "auto";
            if ($event.target.clientWidth / 2 > $event.layerX - $event.target.getBoundingClientRect().left) {
                if (index + 1 === 1) {
                    this.$refs.gallery.scrollTo({ left: this.$refs.gallery.scrollWidth, behavior: smoothscroll });
                } else {
                    this.$refs.gallery.scrollTo({ left: this.$refs.gallery.scrollLeft - this.$refs.slide[index - 1].offsetWidth, behavior: smoothscroll });
                }
            } else {
                if (this.$refs.slide.length === index + 1) {
                    this.$refs.gallery.scrollTo({ left: 0, behavior: smoothscroll });
                } else {
                    this.$refs.gallery.scrollTo({ left: this.$refs.gallery.scrollLeft + this.$refs.slide[index + 1].offsetWidth, behavior: smoothscroll });
                }
            }
        },
  },
}

</script>

<style lang="scss" scoped>
.gallery {
    .gallery-slideshow {
        display: flex;
        width:100%;
        overflow-x:hidden;
        scroll-snap-type: x mandatory;
        @media only screen and (max-width: 768px) {
            overflow-x:auto;
        }
        &::-webkit-scrollbar {
            display: none;
        }
        &.next {
                img {
                    cursor: e-resize;
                }
            }
            &.prev {
                img {
                    cursor: w-resize;
                }
            }
        .gallery-slide {
            height: 50rem;
            width: 100%;
            flex:0 0 auto;
            scroll-snap-align: start;
            display:flex;
            justify-content: flex-start;
            align-items: flex-start;

            @media only screen and (max-width: 1024px) {
                height: 60vw;
            }   
            img {
                max-width: 100%;
                max-height: 100%;
                width:100%;
                height:100%;
                object-fit: contain;
                object-position: top left;
                &.border {
                    border: .65pt solid #000;
                    width: auto;
                    height: auto;
                }
            }
        }
    }
    .gallery-info {
        display: flex;
        justify-content: space-between;
        margin-top: calc(var(--gap) * 0.25);
        height: 6rem;
        font-size: calc(var(--font-size) / 1.75);
        @media only screen and (max-width: 1024px) {
            height: 10rem;
            font-size: var(--font-size);
        }
        .gallery-caption {
            flex: 1 1 auto;
            padding-right: 2rem;
        }
        .gallery-download {
            flex:0 0 auto;
            margin-right: 2rem;
        }
        .gallery-counter {
            flex:0 0 auto;
        }
    }
}
// .larkin-gallery {
//   position: relative;
//   display:block;
//   width: 100%;
//   height: 67%;
//   margin-bottom: calc(var(--gap) * 3);
//     &::-webkit-scrollbar {
//         display: none;
//     }
//     @media only screen and (max-width: 768px) {
//         overflow-x: auto;
//         overflow-y: auto;
//         display: flex;
//         scroll-snap-type: x mandatory;
//         margin-bottom: calc(var(--gap) * 6);
//   }
//   &.next {
//     .larkin-slide {
//       img {
//         cursor: e-resize;
//       }
//     }
//   }
//   &.prev {
//     .larkin-slide {
//       img {
//         cursor: w-resize;
//       }
//     }
//   }
//   .larkin-slide {
//     width: 100%;
//     height: 100%;
//     box-sizing: border-box;
//     margin-right: var(--gap);
//     position: absolute;
//     display:none;
//     @media only screen and (max-width: 768px) {
//         position: relative;
//         flex:0 0 auto;
//         scroll-snap-align: start;
//         display: block;
//     }
//     &.active {
//       display: block;
//     }
//     img {
//       width: 100%;
//       object-fit: contain;
//       object-position: top left;
//       -webkit-user-select: none;
//       -khtml-user-select: none;
//       -moz-user-select: none;
//       -o-user-select: none;
//       user-select: none;
//     }
//     .slide-info {
//       margin-top: calc(var(--line-height) * (var(--font-size) / 6));
//       font-size: calc(var(--font-size) / 1.75);
//       margin-bottom: var(--gap);
//       width: 100%;
//       .slide-caption {
//         display: inline-block;
//         width: 75%;
//       }
//       .slide-counter {
//         display: inline-block;
//         text-align: right;
//         width: 25%;
//         vertical-align: top;
//       }
//     }
//   }
// }
</style>